const cheezy_config = {
    delivery_dates: {
        regular_deliveries: [2, 4],
        extra_deliveries: [],
        no_deliveries: []
    },
    messages: [
      ["Nächstmöglicher Liefertermin am Donnerstag, 24. April 2025", "2025-04-16", "2025-04-21"]
    ]
};

function nextDeliveryDay() {
    const e = new Date();
    let t = e.getDay();
    const n = e.toISOString().slice(0, 10);
    for (let e = 0; e < cheezy_config.messages.length; e++) {
        const t = cheezy_config.messages[e];
        if (null === t[2] && n >= t[1]) return t[0];
        if (n >= t[1] && n <= t[2]) return t[0]
    }
    let r;
    const i = addDays(e, r = t === 1 || t === 2 ? 4 - t : t === 0 ? 2 : 9 - t);
    let l = new Intl.DateTimeFormat("de-DE", {
        weekday: "long",
        day: "numeric",
        month: "numeric"
    }).format(i);
    
    return "Nächstmöglicher Liefertermin am " + (l = l.replace(",", ""))
}

function verifyDate(e, t, n, r, i, l, a) {
    let s = addDays(e, t);
    const o = s.toISOString().slice(0, 10);
    let f, g;
    if (a) {
        f = addDays(e, 2).toISOString().slice(0, 10)
    } else g = e.toISOString().slice(0, 10);
    for (let e = 0; e < i.length; e++)
        if (a) {
            if (i[e] <= o && f <= i[e]) return new Date(i[e])
        } else if (i[e] <= o && i[e] >= g) return new Date(i[e]);
    for (let e = 0; e < l.length; e++)
        if (l[e] === o) {
            for (let e = 0; e < r.length; e++) {
                if (r[e] > s.getDay()) {
                    t = r[e] - s.getDay();
                    break
                }
                e === r.length - 1 && (t = 7 - s.getDay() + r[0])
            }
            return verifyDate(s, t, r[e], r, i, l, !1)
        } return s
}

function addDays(e, t) {
    const n = new Date(e);
    return n.setDate(n.getDate() + t), n
}

function getCurrentDate() {
    let e = new Date;
    return e.setTime(e.getTime() - 60 * e.getTimezoneOffset() * 1e3), e
}

function getDeliveryData(e, t, n, r) {
    let i, l;
    for (let n = 0; n < t.length; n++) {
        if (e + 2 <= t[n]) return i = (l = t[n]) - e, l < e && (i += 7), [l, i];
        if (n === t.length - 1) {
            for (let n = 0; n < t.length; n++)
                if ((e + 2) % 6 <= t[n]) return i = (l = t[n]) - e, l < e && (i += 7), [l, i];
            return 1 === (i = (l = t[0]) - e + 7) && (i += 7), [l, i]
        }
    }
}
element = document.getElementById("notification-bar__message").innerHTML = nextDeliveryDay();